module.exports = __webpack_public_path__ + "img/logo-branco-raia.dfc0cf43.svg";